<template>
  <div class="top-section">
    <!-- <a href="/mobile/#/queryPrecedence">mobile</a> -->
    <div class="top-block">
      <div class="navbar">
        <div @click="goHome()" class="navbar-logo">
          <img class="navbar-logo__inner" src="~@/img/header.png">
        </div>
        <!-- 1:超级管理员 2:管理员 3:专家 4:体验专家 5:会员, 6:体验会员, 7:普通用户 -->
        <div style="flex: 1; height: 100%;">
          <ul class="navbar-ul" v-for="(item, index) in permissionRoutesFilter" style="width: 100%;">
            <li class="navbar-ul__li" v-for="(children, index2) in item.children" v-if="children.meta.isNavbar" :index="children.path">
              <router-link :to="{ path: children.path }" rel="opener" target="_blank" @click.native.prevent="goRouter(children)"
                           :class="$route.path == children.path ? 'is-active' : 'not-active'">{{ children.meta.title }}
              </router-link>
            </li>
            <li class="navbar-ul__li" v-if="$store.state.userInfo">
              <img class="navbar-avatar" src="~@/assets/images/default-avatar.png">
              <img v-if="$store.state.userInfo.sex === 0" class="navbar-avatar" src="~@/assets/images/sex_0.jpg">
              <img v-if="$store.state.userInfo.sex === 1" class="navbar-avatar" src="~@/assets/images/sex_1.jpg">
              <el-dropdown trigger="click" class="modify-dropdown">
								<span class="modify-dropdown__link">
									<span class="navbar-username">{{ $store.state.userInfo.nickName }}</span>
									<span class="navbar-username">{{ $store.state.userInfo.sex }}</span>
									<i style="color: #dedede; font-size: 10px; margin-left: 16px;" class="el-icon-caret-bottom"></i>
								</span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item class="clearfix" style="padding: 0;width:80px;">
                    <span @click="logout()" style="display: inline-block;width: 100%;text-align: center;">退出登录</span>
                    <!-- <el-badge class="mark" /> -->
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <el-backtop target=".wrapper" :visibility-height="300" :bottom="150" :right="20"
                style="width: 50px;height: 50px;font-size: 15px;color:orangered;">
      <span style="font-size: 20px;">↑</span>顶部
    </el-backtop>
  </div>
</template>
<script>
import {request} from "@/util/request.js"
import { mapGetters } from 'vuex'

export default {
  inject: ['reload'],
  data() {
    return {
      url: 'https://beian.miit.gov.cn/',
      user: {},
      wxid: null,
      userbolean: false,
      expert: true
    }
  },
  computed: {
    ...mapGetters([
      'userInfo',
      'permissionRoutes',
      'permissionNavbarRoutes'
    ]),
    permissionRoutesFilter() {
      if (this.userInfo) {
        let navbarRoutes = this.permissionNavbarRoutes.map(item => {
          item.children = item.children.filter(children => children.path !== '/main')
          return item
        })
        return navbarRoutes
      }
      return this.permissionRoutes//.filter(item => )
    },
  },
  methods: {
    goRouter(item) {
      const routeData = this.$router.resolve({
				path: item.path,
			})
      const isOpenWindow = () => {
        item.meta.openWindow === false
          ? this.$router.push({ path: item.path })
          : window.open(routeData.href, item.meta?.title || item.path)
      }
      if (!item.meta.requiresAuth) {
        return isOpenWindow()
      }
      let token = sessionStorage.getItem('satoken');
      if (!token && routeData.href != "#/main") {
        //提示用户登录
        this.$message.error('请先登录...');
      } else {
        isOpenWindow()
      }
    },

    goHome() {
      this.$router.push("/")
    },
    togxb() {
      window.open(this.url)
    },
    toSignin() {
      this.$router.push({
        path: "/login",
        query: {
          action: 'teacher'
        }
      })
    },
    toSigninx() {
      this.$router.push({
        path: "/login",
        query: {
          action: 'student'
        }
      })
    },
    logout() {
      // console.log("用户退出登录...")
      request({
        method: 'get',
        url: 'sysUser/logout'
      }).then(res => {
        if (res.code == null || res.code == 0) {
          sessionStorage.removeItem("satoken")
          sessionStorage.removeItem("user")
          this.userbolean = false
          // console.log("成功！")
        }
      })
      this.$store.dispatch('logout')
      this.user = null
      if (this.$route !== '/main') {
        this.$router.push({path: '/'});
      }
    },
    wxlogin() {
      request({
        method: 'POST',
        url: 'sysUser/wxlogin',
        data: this.wxid
      }).then(msg => {
        if (msg.data.state === 0) {
          this.$message({
            message: "登录成功！",
            type: "success"
          });
          console.log("登录成功");
          this.reload();
          sessionStorage.setItem(msg.data.tokenInfo.tokenName, msg.data.tokenInfo.tokenValue)
          sessionStorage.setItem('user', JSON.stringify(msg.data.user[0]))
          this.$store.dispatch('login', msg.data)
          this.$router.push({
            path: '/policy',
            query: {}
          });
          // window.open("https://www.51mydoor.com", '_self ')
        } else {
          this.$alert('请先注册一个账号', '提示', {
            confirmButtonText: '确定',
            callback: action => {
              this.activeName = "second"
            }
          });
        }
      })
    },
    bdwx() {
      request({
        method: 'post',
        url: 'sysUser/bdwx',
        data: {
          openid: this.wxid,
          userId: this.user.userId
        }
      }).then(result => {
        if (result.code == 0 || result.code == 200) {
          this.$message({
            message: result.msg,
            type: "success"
          });
        } else {
          this.$message({
            message: result.msg,
            type: "error"
          });
        }
      })
    },
  },
  created() {
    this.user = this.$store.state.userInfo
    const zhi = location.search.slice(1).split("&")
    const code = JSON.stringify(JSON.parse(JSON.stringify(zhi)))
    const code1 = JSON.parse(code.split(','));
    const code2 = JSON.stringify(code1[0]);
    const code3 = code2.slice(6);
    const code4 = code3.slice(0, code3.length - 1);
    if (this.user != null && this.user.nickName != null && this.user.nickName != "") {
      this.userbolean = true
      if (this.user.userType == 3) {
        this.expert = true
      } else if (this.user.userType == 4 && code4 != null && code4 != undefined && !this.user.openid) {
        request({
          method: 'post',
          url: 'sysUser/getAccessToken',
          params: {
            code: code4
          }
        }).then(res => {
          const weix = JSON.parse(res.msg)
          if (weix.hasOwnProperty('openid')) {
            this.wxid = weix.openid
            this.bdwx()
          }
        })
      }
    } else {
      if (!['', null, undefined].includes(code4)) {
        request({
          method: 'post',
          url: 'sysUser/getAccessToken',
          params: {
            code: code4
          }
        }).then(res => {
          const weix = JSON.parse(res.msg)
          if (weix.hasOwnProperty('openid')) {
            this.user = JSON.parse(user)
            this.wxid = weix.openid
            this.wxlogin()
          }
        })
      }
    }

  },
  mounted() {
  },
}
</script>

<style lang="stylus" scoped>
body::-webkit-scrollbar {
  display: none;
}

navbarHeight = 75px
.top-section
  position: sticky;
  top 0
  z-index 10
  width: 100%;
  height: navbarHeight;

.top-block
  width: 100%;
  height: navbarHeight;
  z-index: 999;
  background-color: white;
// border-bottom 1px solid #e7eaed
.navbar
  width: 1440px;
  height: navbarHeight;
  min-width: 1440px;
  flex 0
  margin 0 auto
  background-color white
  display flex
  align-items center

  &-logo
    display inline-block
    width 216px
    line-height navbarHeight
    height navbarHeight
    vertical-align top
    cursor pointer
    flex-shrink 0
    margin-left -15px

    &__inner
      width 100%
      height auto
      margin-top: 15px;
  &-ul
    list-style none
    height navbarHeight
    line-height navbarHeight
    padding 0
    margin 0
    display: flex
    justify-content flex-end
    width 100%

    &__li
      font-size: 15px;
      height: navbarHeight;
      line-height: navbarHeight;
      font-size: 16px;
      font-weight: PingFangMedium500;
      color: #333;

      & > a
        display block
        height 100%
        position relative

        &::after
          content " "
          position absolute
          bottom 1px
          left 0
          opacity 0
          width 100%
          height: 6px;
          transform: scaleX(0);
          transition: all .2s;
        &.router-link-active
          color PrimaryColor

          &::after
            background: PrimaryColor;
            border-radius: 3px;
            opacity: 1;
            transform: scaleX(1);

      & + &
        margin-left 34px

  &-avatar
    width 35px
    height 35px
    vertical-align middle
    margin-right 19px

  &-username
    overflow: hidden;
    text-overflow: ellipsis;
    -o-text-overflow: ellipsis;
    white-space: nowrap;
    max-width: 80px;
    display: inline-block;

.modify-dropdown
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #666666;
  margin-left: 5px;
  line-height: initial;
  &__link
    display: flex;
    align-items: center;
    cursor pointer
.btnzf {
  width: 6.25rem;
  height: 1.875rem;
  border-radius: 0.3125rem;
  background-color: #ff7f50;
  color: white;
  border: none;
  margin-top: 3.125rem;
}

#app {
  /* position:absolute; */
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
}

html,
body {
  height: 100%;
  width: 100%;
}

.div3 {
  flex: 0;
}
</style>
